/**
 * Changes the default submit button as indicated by the data-submit="[id]" attribute when pressing enter on an input
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/attributes/data/data.js";

export default (obj, name) => {
	obj.on("keydown", function (e) {
		const data = $(this).data(name),
			target = $(data ? "#" + data : null);
		if (target.length && e.key === "Enter") {
			e.preventDefault();
			target[0].click();
		}
	});
};
